export function daysAgo(date) {
  return Math.round((new Date() - new Date(date)) / (1000 * 60 * 60 * 24));
}
